/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { InboxMessageResponse } from './inboxMessageResponse';
import type { InboxThreadResponseBounceClassification } from './inboxThreadResponseBounceClassification';
import type { InboxThreadResponseClassification } from './inboxThreadResponseClassification';
import type { InboxThreadResponseDraftBodyJson } from './inboxThreadResponseDraftBodyJson';
import type { InboxThreadResponseDraftStatus } from './inboxThreadResponseDraftStatus';
import type { InboxThreadResponseLastMessageDirection } from './inboxThreadResponseLastMessageDirection';
import type { InboxThreadResponseManualClassification } from './inboxThreadResponseManualClassification';
import type { ScheduledTask } from './scheduledTask';
import type { SidePanelSummary } from './sidePanelSummary';

/**
 * Full ``GET /inbox/threads/{thread_id}`` body.
 */
export interface InboxThreadResponse {
  id: string;
  channel?: 'email';
  job_candidate_id: string;
  /** @maxLength 200 */
  candidate_name: string;
  candidate_avatar_url?: string | null;
  candidate_headline?: string | null;
  subject?: string | null;
  /** @maxLength 500 */
  snippet: string;
  last_message_at: string;
  classification?: InboxThreadResponseClassification;
  manual_classification?: InboxThreadResponseManualClassification;
  classification_confidence?: number | null;
  draft_status?: InboxThreadResponseDraftStatus;
  bounced?: boolean;
  /** @minimum 0 */
  unread_count: number;
  last_message_direction?: InboxThreadResponseLastMessageDirection;
  last_sender_name?: string | null;
  last_sender_avatar_url?: string | null;
  messages?: InboxMessageResponse[];
  side_panel_summary: SidePanelSummary;
  scheduled_tasks?: ScheduledTask[];
  draft_body_json?: InboxThreadResponseDraftBodyJson;
  draft_subject?: string | null;
  draft_failure_reason?: string | null;
  bounce_classification?: InboxThreadResponseBounceClassification;
  mailbox_connected?: boolean;
}
